module.exports = __webpack_public_path__ + "static/media/move-backward-tool-white.cf1c9dc0.svg";